import {useAPI} from '@/api/api';
import { IFMessageCountRsp, IFMessageRsp } from "@/api/apiRsp/IFMessageRsp";
import { IFMessageReq } from "@/api/apiReq/IFMessageReq";
import {mutate} from "swr";

//通知消息
export function useNoticeMessage(Params) {
  const { data, isLoading, isValidating, error, mutate, revalidate } = useAPI<IFMessageRsp, IFMessageReq>(
    { path: '/email/userMessages/list', type: 'post', needLogin: true }, Params);
  return { data, isLoading, isValidating, error, mutate, revalidate };
}

//通知消息
export function clearNoticeMessage() {
  mutate('/email/userMessages/list',null,{revalidate:true})
}



//通知消息数量
export function useMessageCount() {
  const { data, isLoading, isValidating, error, mutate, revalidate } = useAPI<IFMessageCountRsp, any>({ path: '/email/userMessages/count', type: 'get', needLogin: true },null,{
    revalidateOnMount: false
  });
  return { data, isLoading, isValidating, error, mutate, revalidate };
}
